import styled from "styled-components";
import Feature1 from "../../../assets/img/feature1.png";
import Feature2 from "../../../assets/img/feature2.png";
import { Col, Container, Row } from "react-bootstrap";
import { DARK_KUBBE } from "../../../constants/Colors";
import { useHistory, useLocation } from "react-router-dom";

const FeatureCard = styled.div`
  position: relative;
  background-color: transparent;
  max-width: 730px;
  width: 100%;
  border-radius: 40px;
  @media (max-width: 991px) {
    width: 100%;
  }
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.08);
  img {
    width: 100%;
    height: auto;
    background-color: transparent;
    border-radius: 40px;
    box-shadow: 10px 10px 20px ${DARK_KUBBE}80;
  }
`;

const TextContent = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  align-content: center;
  text-align: center;
  h1 {
    font-size: clamp(1rem, 2.5vw, 40px);
    font-family: "Raleway";
    font-weight: 500;
    margin: 0;
    color: #fff;
    @media (max-width: 768px) {
      font-size: clamp(1rem, 5.5vw, 40px);
    }
  }
  h1 strong {
    font-weight: 700;
  }
`;

const FeaturesSection = () => {
  const history = useHistory();

  return (
    <Row className="mt-4 mx-1 mx-md-4">
      <Col md={6} className="d-flex justify-content-center">
        <FeatureCard
          className="cursor-pointer"
          onClick={() => history.push("/register?type=carriers")}
        >
          <img src={Feature1} alt="Transportistas" />
          <TextContent>
            <h1>
              Soy <strong>TRANSPORTISTA</strong>, quiero
              <br /> encontrar cargas cerca y sin <br />
              intermediarios.
            </h1>
          </TextContent>
        </FeatureCard>
      </Col>
      <Col md={6} className="d-flex justify-content-center mt-4 mt-md-0">
        <FeatureCard
          className="cursor-pointer"
          onClick={() => history.push("/register?type=Loadgiver")}
        >
          <img src={Feature2} alt="Dadores de carga" />
          <TextContent>
            <h1>
              Soy <strong>DADOR DE CARGA</strong>, quiero <br /> conectar con
              transportistas <br /> confiables al mejor precio.
            </h1>
          </TextContent>
        </FeatureCard>
      </Col>
    </Row>
  );
};

export default FeaturesSection;
